import { render, staticRenderFns } from "./IconLive02.vue?vue&type=template&id=db80b1bc"
import script from "./IconLive02.vue?vue&type=script&lang=ts"
export * from "./IconLive02.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports